export default __webpack_public_path__ + "alberta-stop.debcd74ec53913690da1.svg";